import { useMemo } from 'react';
import type { RampConfig } from '@gorampe/calc-engine';
import type { SceneLayout } from '../types';
import { dispatchLayout } from '../layouts';

export function useRampScene(config: RampConfig): SceneLayout {
  return useMemo(() => dispatchLayout(config), [config]);
}
